( function () {
	const blocks = document.querySelectorAll( '.wp-block-milestonevideo-theme-klienci' );
	if ( ! blocks.length ) {
		return;
	}

	const prefersReduced = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	const revealAll = () => {
		blocks.forEach( ( block ) => {
			block.querySelectorAll( '.reveal' ).forEach( ( el ) => el.classList.add( 'in' ) );
		} );
	};

	if ( prefersReduced || ! ( 'IntersectionObserver' in window ) ) {
		revealAll();
		return;
	}

	// top < 90% viewportu → wejście (1:1 z threshold exportu: vh * 0.9)
	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					entry.target.classList.add( 'in' );
					observer.unobserve( entry.target );
				}
			} );
		},
		{ threshold: 0, rootMargin: '0px 0px -10% 0px' }
	);

	blocks.forEach( ( block ) => {
		block.querySelectorAll( '.reveal' ).forEach( ( el ) => observer.observe( el ) );
	} );
} )();
